<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <!-- search condition start -->
    <el-row class="flex">
      <el-input
        v-model="searchCondition.keyword"
        clearable
        size="small"
        :placeholder="$t('名称描述')"
        class="w-200px mr-10px"
      ></el-input>
      <el-select
        class="w-200px mr-10px"
        v-model="searchCondition.type"
        filterable
        allow-create
        clearable
        size="small"
      >
        <el-option
          v-for="item in apiTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        class="w-200px mr-10px"
        size="small"
        clearable
        v-model="searchCondition.audit_state"
        :placeholder="$t('请选择状态')"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="(item, index) in auditStutusList"
          :key="index"
        ></el-option>
      </el-select>
      <el-input
        v-model="searchCondition.name"
        clearable
        size="small"
        placeholder="应用"
        class="w-200px mr-10px"
      ></el-input>
      <el-input
        v-model="searchCondition.department_id"
        clearable
        size="small"
        placeholder="部门"
        class="w-200px mr-10px"
      ></el-input>
      <el-button type="primary" @click="searchTableData()">{{ $t('search') }}</el-button>
      <el-button
        :disabled="!$hasAccess('approved') || selectList.length === 0"
        type="primary"
        @click="approved"
        :loading="approvedLoading"
        >审核通过</el-button
      >
      <el-button
        :disabled="!$hasAccess('unapproved') || selectList.length === 0"
        type="primary"
        @click="unapproved"
        :loading="unapprovedLoading"
        >审核不通过</el-button
      >
    </el-row>
    <!-- search condition end -->
    <!-- table start -->
    <el-table
      :data="tableData"
      border
      class="mt-20px"
      height="calc(100% - 106px)"
      v-loading="tableLoading"
      row-key="applyOpenApiRecordId"
      @selection-change="selectionChange"
      ref="table"
    >
      <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
      <el-table-column
        :label="$t('名称')"
        prop="openApiName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        :label="$t('类型')"
        prop="openApiType"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        :label="$t('描述')"
        prop="openApiDescription"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        :label="$t('申请应用')"
        prop="applyApplicationName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column :label="$t('申请部门')" prop="applyDepartment" show-overflow-tooltip>
      </el-table-column>
      <el-table-column :label="$t('状态')" width="120" prop="auditStatusName" show-overflow-tooltip>
      </el-table-column>
      <el-table-column :label="$t('操作')" width="200">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleRow(scope.row, 'read')"
            :disabled="!$hasAccess('read')"
            >查看</el-button
          >
          <el-button
            :disabled="!$hasAccess('update') || scope.row.auditStatus >= 3"
            size="mini"
            @click="handleRow(scope.row, 'examine')"
            >审核</el-button
          >
          <el-button :disabled="!$hasAccess('delete')" size="mini" @click="deleteRow(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- table end -->
    <!-- pagigation start -->
    <el-pagination
      class="mt-20px float-right"
      background
      @size-change="searchTableData()"
      @current-change="findTableData()"
      :current-page.sync="page.pageNo"
      :page-sizes="$pageSizeAll"
      :page-size.sync="page.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="page.pageTotal"
    ></el-pagination>
    <!-- pagigation end -->
  </el-card>
</template>

<script>
import { ApplyApplicationApi, OpenApiApi } from '@wiz-api/open-api-management'

const applyApplicationApi = new ApplyApplicationApi()
const openApiApi = new OpenApiApi()
export default {
  name: 'apiApply',
  components: {},
  data() {
    return {
      tableLoading: true,
      apiTypes: [],
      tableData: [],
      apiMethods: [], // api请求方式
      searchCondition: {
        keyword: '',
        type: '',
        audit_state: '',
        name: '',
        department_id: '',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      auditStutusList: [],
      selectList: [],
      approvedLoading: false,
      unapprovedLoading: false,
    }
  },
  computed: {
    organizationList() {
      return this.$store.getters['System/organizationList']
    },
    tableHeight() {
      return `${window.innerHeight - 220}px`
    },
  },
  methods: {
    selectionChange(val) {
      this.selectList = _.map(val, (item) => {
        return item.applyOpenApiRecordId
      })
    },
    // 批量审核通过
    async approved() {
      this.approvedLoading = true
      const [err, res] = await applyApplicationApi.approveApplyOpenApi({
        body: {
          applyOpenApiRecordIds: this.selectList,
          isPass: true,
        },
      })
      this.approvedLoading = false
      if (!err) {
        this.$message.success('审核通过')
        this.searchTableData()
        this.selectList = []
        this.$nextTick(() => {
          this.$refs.table.clearSelection()
        })
      }
    },
    // 批量审核不通过
    async unapproved() {
      this.unapprovedLoading = true
      const [err, res] = await applyApplicationApi.approveApplyOpenApi({
        body: {
          applyOpenApiRecordIds: this.selectList,
          isPass: false,
        },
      })
      this.unapprovedLoading = false
      if (!err) {
        this.$message.success('审核不通过')
        this.searchTableData()
        this.selectList = []
        this.$nextTick(() => {
          this.$refs.table.clearSelection()
        })
      }
    },
    async getAuditStatus() {
      const [err, res] = await applyApplicationApi.getAuditStatus({ isContainNotSubmitStatus: 0 })
      if (!err) {
        this.auditStutusList = _.map(res, (item) => {
          return {
            label: item.item2,
            value: item.item1,
          }
        })
      }
    },
    computeOrganization(name) {
      const currentRow = _.find(this.organizationList, ['id', name])
      return currentRow ? currentRow.name : name
    },
    deleteRow(row) {
      this.$confirm('是否确定要删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.tableLoading = true
          const [err, res] = await applyApplicationApi.deleteApplyOpenApiRecords(
            row.applyOpenApiRecordId
          )
          this.tableLoading = false
          if (!err) {
            this.$message.success('删除成功')
            if (this.tableData.length === 1 && this.page.pageNo > 1) {
              this.page.pageNo -= 1
              this.findTableData()
              return
            }
            this.findTableData()
          }
        })
        .catch(() => {
          this.$message.info('取消删除')
        })
    },
    handleRow(row, type) {
      this.$router.push(
        `./api-examine?applicationId=${row.applyApplicationId}&apiId=${row.openApiId}&id=${row.applyOpenApiRecordId}&type=${type}`
      )
    },
    async findApiType() {
      const [err, res] = await openApiApi.getDistinctApiType()
      if (!err) {
        this.apiTypes = _.map(res, (item) => {
          return {
            label: item,
            value: item,
          }
        })
      }
    },
    searchTableData() {
      this.page.pageNo = 1
      this.findTableData()
    },
    async findTableData() {
      // const searchParams = _.cloneDeep(this.searchCondition)
      // searchParams.audit_state =
      //   searchParams.audit_state === ''
      //     ? {
      //         $in: '1,2,3',
      //       }
      //     : searchParams.audit_state
      const reqData = {
        skipCount: this.page.pageNo,
        maxResultCount: this.page.pageSize,
        sorting: '',
        keywords: this.searchCondition.keyword,
        apiType: this.searchCondition.type,
        auditStatus: this.searchCondition.audit_state,
        name: this.searchCondition.name,
        department: this.searchCondition.department_id,
        isQueryNotSubmittedRecord: 0, // 是否查询未提交记录，0=不查询，1=查询
      }
      this.tableLoading = true
      const [err, res] = await applyApplicationApi.getApplyOpenApiRecordPagedResult(reqData)
      this.tableLoading = false
      if (!err) {
        this.tableData = res.items
        this.page.pageTotal = res.totalCount
        _.forEach(this.tableData, (item) => {
          item.apiState = item.apiState === 0 // 0 启用 1 停用
        })
      }
    },
  },
  async created() {
    this.findApiType()
    this.getAuditStatus()
    this.searchTableData()
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>

/deep/ .el-form-item {
  margin-bottom: 0px !important;
}

</style>
